var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ms-row",style:({
    'align-items':_vm.msAlign,
    'justify-content':_vm.msJustify,
    'display':_vm.msType,
    'overflow': _vm.msType === 'block' ? 'hidden' : null,
    'width': _vm.getWidth,
    'height': _vm.height,
    'line-height': _vm.getLineHeight,
    'text-indent': _vm.textIndent + 'px',
    'padding': _vm.padding + 'px',
    'text-indent': _vm.textIndent + 'px',
    'margin-bottom': _vm.msMb})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }